import React from "react";
import CardDeckView from "../snippet/CardDeckView";
import BlockIntroView from "../snippet/BlockIntroView";
import {IContentBlock} from "../../../ts/data/subject/PostDataHelper";

const PostsLayoutView = (block: IContentBlock) =>
{
    const routeChoiceList = block.posts ?? [];
    const items = (block.numberOf ?? 0) > 0 ? routeChoiceList?.slice(0, block.numberOf) : routeChoiceList;
    let isSlick = block.layout === "slideshow" && (routeChoiceList.length > 1);
    if(block.desktopColumns === 4 && (routeChoiceList.length < 5)){
        isSlick = false;
    }
    const cardsID = "standardCards-"+Math.random();
    return <>
        {!!block.anchor && <>
            <div id={block.anchor}></div>
        </>}
        <div className="container">
            <BlockIntroView {...block}/>
            {((block.layout === "cards") || (block.layout === "slideshow") || !block.layout) && <>
                <CardDeckView routeChoiceList={items} isSlick={isSlick} removeData={true} useID={cardsID} desktopCols={block.desktopColumns ?? 3} rotateColours={block.rotateColours} />
            </>}
        </div>
    </>
}
export default PostsLayoutView;